import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    padding: '8px 13px',
  },
  yellowText: {
    color: theme.palette.yellow.color,
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  listPaginationItem: {
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
}))
